export const environment = {
  production: true,
  rootUrl: 'https://pigbank.kr',
  s3: {
    bucketname: 'pig-bank',
  },
};
